import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

import NewMaterialRequest from "../pages/Material/NewMaterialRequest/NewMaterialRequest";
import NewServiceRequest from "../pages/Service/NewServiceRequest/NewServiceRequest";
import MaterialRequestDashboard from "../pages/Material/MaterialRequest/index";
import ServiceRequestDashboard from "../pages/Service/ServiceRequest/index";
import MaterialRequest from "../pages/Material/MaterialRequest/MaterialRequest";
import ServiceRequest from "../pages/Service/ServiceRequest/ServiceRequest";
import MyMRDashboard from "../pages/Material/MyMaterialRequest/index";
import MySRDashboard from "../pages/Service/MyServiceRequest/index";
import MyMaterialRequest from "../pages/Material/MyMaterialRequest/myMaterialRequest";
import MyServiceRequest from "../pages/Service/MyServiceRequest/myServiceRequest";
import DeptMRDashboard from "../pages/Material/DeptMaterialRequest/index";
import DeptSRDashboard from "../pages/Service/DeptServiceRequest";
import DeptMaterialRequest from "../pages/Material/DeptMaterialRequest/DeptMaterialRequest";
import DeptServiceRequest from "../pages/Service/DeptServiceRequest/DeptServiceRequest";
import AllMRDashboard from "../pages/Material/AllMaterialRequest/index";

import AllServiceRequestDashboard from "../pages/Service/AllServiceRequest/index";
import AllMaterialRequest from "../pages/Material/AllMaterialRequest/MaterialRequestView";
import ServiceRequestView from "../pages/Service/AllServiceRequest/ServiceRequestView";

import NewPurchaseIndentRequest from "../pages/PurchaseIndent/NewPurchaseRequest/NewPurchaseRequest";
import NewSRPurchaseIndentRequest from "../pages/SRPurchaseIndent/NewSRPurchaseRequest/NewSRPurchaseRequest";
import MyPurchaseIndentDashboard from "../pages/PurchaseIndent/MyPurchaseIndent/index";
import MySRPurchaseIndentDashboard from "../pages/SRPurchaseIndent/MyPurchaseIndent/index";
import PurchaseIndentRequest from "../pages/PurchaseIndent/MyPurchaseIndent/PurchaseIndentRequest";
import SRPurchaseIndentRequest from "../pages/SRPurchaseIndent/MyPurchaseIndent/PurchaseIndentRequest";
import HodPurchaseIndentDashboard from "../pages/PurchaseIndent/HodPurchaseIndent/index";
import SRHodPurchaseIndentDashboard from "../pages/SRPurchaseIndent/HodPurchaseIndent/index";
import HodPurchaseIndentRequest from "../pages/PurchaseIndent/HodPurchaseIndent/HodPurchaseIndentRequest";
import HodSRPurchaseIndent from "../pages/SRPurchaseIndent/HodPurchaseIndent/HodPurchaseIndentRequest";

import RequestForQuotationDashboard from "../pages/RequestForQuotation/index";
import SRRequestForQuotation from "../pages/SRRequestForQuotation/index";
import NewRequestForQuotation from "../pages/RequestForQuotation/NewRequestForQuotation/NewRequestForQuotation";
import NewSRRequestForQuotation from "../pages/SRRequestForQuotation/NewSRRequestForQuotation/NewSRRequestForQuotation";
import RequestForQuotation from "../pages/RequestForQuotation/RequestForQuotationTask/RequestForQuotation";
import SRRequestForQuotationView from "../pages/SRRequestForQuotation/SRRequestForQuotationTask/SRRequestForQuotation";

import QuotationDashboard from "../pages/Quotation/index";
import SRQuotationDashboard from "../pages/SRQuotation/index";
import NewQuotation from "../pages/Quotation/NewQuotation/NewQuotation";
import NewSRQuotation from "../pages/SRQuotation/NewSRQuotation/NewSRQuotation";
import Quotation from "../pages/Quotation/QuotationTask/Quotation";
import SRQuotation from "../pages/SRQuotation/QuotationTask/Quotation";
import NewWorkOrder from "../pages/SRPurchaseOrder/NewWorkOrder/NewSRQuotation";
import CompareQuotationDashboard from "../pages/CompareQuotation/index";
import SRCompareQuotationDashboard from "../pages/SRCompareQuotation/index";
import NewCompareQuotation from "../pages/CompareQuotation/NewCompareQuotation/NewCompareQuotation";
import NewSRCompareQuotation from "../pages/SRCompareQuotation/NewSRCompareQuotation/NewSRCompareQuotation";
import CompareQuotation from "../pages/CompareQuotation/CompareQuotationTask/CompareQuotation";
import SRCompoareQuotation from "../pages/SRCompareQuotation/SRCompareQuotationTask/CompareQuotation";

import PurchaseOrderDashboard from "../pages/PurchaseOrder/index";
import SRPurchaseOrder from "../pages/SRPurchaseOrder/index";
import PurchaseOrder from "../pages/PurchaseOrder/PurchaseOrderTask/PurchaseOrder";
import SRPurchaseOrderView from "../pages/SRPurchaseOrder/PurchaseOrderTask/PurchaseOrder";
import PurchaseOrderEdit from "../pages/PurchaseOrder/PurchaseOrderTask/PurchaseOrderEdit";

import InGatePassDashboard from "../pages/ingatepass/index";
import InGatePass from "../pages/ingatepass/InGatePassTask/InGatePass";
import NewInGatePass from "../pages/ingatepass/NewInGatePass/NewInGatePass";

import UserProfile from "../pages/UserProfile/UserProfile";
import ChangePassword from "../pages/UserProfile/ChangePassword";
import SystemSettings from "../pages/System/SystemSettings";
import ExportCSV from "../pages/ImportExport/export-csv";

import ImportCSV from "../pages/ImportExport/import-csv";
//
import MastersDashboard from "../pages/MastersDashboard/Index";
import Companysetting from "../pages/CompanySettings/CompanyDetails";

//
import Companylist from "../pages/CompanySettings/UsersProfile/Index";
import AddProfile from "../pages/CompanySettings/UsersProfile/AddProfile/Index";
import EmailSMS from "../pages/CompanySettings/EmailSMS";
import ImportData from "../pages/CompanySettings/ImportData/ImportData";
import Yourdevices from "../pages/CompanySettings/yourdevices/yourdevices";
import SecurityDashboard from "../pages/CompanySettings/SecurityDashboard/SecurityDashboard";

// //Mater pages
import Companys from "../pages/Companys/Companys";
import Menus from "../pages/MastersDashboard/Menus/Menu";
import MenuItems from "../pages/MastersDashboard/MenuItems/MenuItems";
import departments from "../pages/MastersDashboard/Departments/Departments";
import locations from "../pages/MastersDashboard/Locations/Locations";
import quality from "../pages/MastersDashboard/quality/Quality";
import Sublocations from "../pages/MastersDashboard/SubLocations/SubLocations";
import OrderLocations from "../pages/MastersDashboard/OrderLocations/OrderLocations";
import ProductGroup from "../pages/MastersDashboard/ProductGroup/ProductGroup";
import Products from "../pages/MastersDashboard/Products/Products";
import AddProducts from "../pages/MastersDashboard/Products/AddProducts";
import AddProductsQuality from "../pages/MastersDashboard/productQuality/AddProductQuality";
import Vendors from "../pages/MastersDashboard/Vendors/Vendors";
// import AddVendor from "../pages/MastersDashboard/Vendors/AddVendor";
// import AddProductVendor from "../pages/MastersDashboard/Products/AddProductVendor";
import Category from "../pages/MastersDashboard/Category/Category";
import Section from "../pages/MastersDashboard/Section/Section";
import BasicUnit from "../pages/MastersDashboard/BasicUnit/BasicUnit";
import Taxs from "../pages/MastersDashboard/Taxs/Taxs";
import PrefixCode from "../pages/MastersDashboard/PrefixCode/PrefixCode";
// import ImportProducts from "../pages/Imports/ImportProducts";
// import ImportVendors from "../pages/Imports/ImportVendors";

//VendorLogin
import VendorLogin from "../pages/VendorQuotation/VendorLogin";
import VendorQuotationLayout from "../pages/VendorQuotation/VendorQuotationindex";
import VendorQuotationtReport from "../pages/VendorQuotation/VendorQuotationReportDocument";
//VendorPO
import VendorPO from "../pages/VendorPO/VendorPOReportDocument";

//Reports
import ReportsDashboard from "../pages/Reports/ReportsDashboard";
import MRReports from "../pages/Reports/MaterialRequest/MRReports";
import SRReports from "../pages/Reports/ServiceRequest/SRReports";
import MRReportList from "../pages/Reports/MaterialRequest/MRReportList";
import SRReportList from "../pages/Reports/ServiceRequest/SRReportList";
import MRReportDocument from "../pages/Reports/MaterialRequest/MRReportDocument";
import SRReportDocument from "../pages/Reports/ServiceRequest/SRReportDocument";

import PIReports from "../pages/Reports/PurchaseIndent/PIReports";
import PIReportList from "../pages/Reports/PurchaseIndent/PIReportList";
import MRTimelLineReportList from "../pages/Reports/MRTimeLineReport/MRTimeLineList";
import SRTimelLineReportList from "../pages/Reports/SRTimeLineReport/SRTimeLineList";
import PIReportDocument from "../pages/Reports/PurchaseIndent/PIReportDocument";
import MRTimelLineReportDocument from "../pages/Reports/MRTimeLineReport/MRTimeLineReportDoc";
import SRTimelLineReportDocument from "../pages/Reports/SRTimeLineReport/SRTimeLineReportDoc";

import SIReports from "../pages/Reports/ServiceIndent/SIReports";
import SIReportList from "../pages/Reports/ServiceIndent/SIReportList";
import SIReportDocument from "../pages/Reports/ServiceIndent/SIReportDocument";

import RFQReports from "../pages/Reports/RequestForQuotation/RFQReports";
import RFQToPPReports from "../pages/Reports/RFQPendingReport/RFQPendingReport";
import RFQToPPReportsList from "../pages/Reports/RFQPendingReport/RFQPendingReportList";
import RFQReportList from "../pages/Reports/RequestForQuotation/RFQReportList";
import RFQReportDocument from "../pages/Reports/RequestForQuotation/RFQReportDocument";
import RFQVendorWiseReportDocument from "../pages/Reports/RequestForQuotation/RFQVendorWiseReport";
import SRRFQReports from "../pages/Reports/SRRequestForQuotation/SRRFQReports";
import SRRFQReportList from "../pages/Reports/SRRequestForQuotation/SRRFQReportList";
import SRReportDocument2 from "../pages/Reports/SRRequestForQuotation/SRRFQReportDocument";

import QReports from "../pages/Reports/Quotation/QuotationReports";
import QReportList from "../pages/Reports/Quotation/QuotationReportList";
import QReportDocument from "../pages/Reports/Quotation/QuotationReportDocument";

import SRQReport from "../pages/Reports/SRQuotation/SRQuotationReports";
import SRQReportList from "../pages/Reports/SRQuotation/SRQuotationReportList";
import SRQuotationReportDocument from "../pages/Reports/SRQuotation/SRQuotationReportDocument";

import UnitReport from "../pages/Reports/UnitWisePending/UnitWiseReports";
import UnitReportList from "../pages/Reports/UnitWisePending/UnitWiseReportList";
import UnitReportDocument from "../pages/Reports/UnitWisePending/UnitWiseReportDocument";

import CQReports from "../pages/Reports/CompareQuotation/CQReports";
import CQReportList from "../pages/Reports/CompareQuotation/CQReportList";
import CQReportDocument from "../pages/Reports/CompareQuotation/CQReportDocument";

import SRCQReports from "../pages/Reports/SRCompareQuotation/SRCQReports";
import SRCQReportList from "../pages/Reports/SRCompareQuotation/SRCQReportList";
import SRCQReportDocument from "../pages/Reports/SRCompareQuotation/SRCQReportDocument";

import POReports from "../pages/Reports/PurchaseOrder/POReports";
import POReportList from "../pages/Reports/PurchaseOrder/POReportList";
import POReportDocument from "../pages/Reports/PurchaseOrder/POReportDocument";
import SRPOReports from "../pages/Reports/SRPurchaseOrder/SRPOReports";
import SRPORTList from "../pages/Reports/SRPurchaseOrder/SRPOReportList";
import SRPOReportDocument from "../pages/Reports/SRPurchaseOrder/SRPOReportDocument";
import POItemReportList from "../pages/Reports/PurchaseOrder/POItemReportList";
import SRPOItemReportList from "../pages/Reports/SRPurchaseOrder/SRPOItemReportList";

// Amendament Reports
import POAmendamentReports from "../pages/Reports/POAmendamentHistory/POAmendamentReports";
import POAmendamentReportList from "../pages/Reports/POAmendamentHistory/POAmendamentReportList";
import POAmendamentReportDocument from "../pages/Reports/POAmendamentHistory/POAmendamentReportDocument";

import IGPReports from "../pages/Reports/IGP/IGPReports";
import IGPReportList from "../pages/Reports/IGP/IGPReportList";
import IGPReportPOList from "../pages/Reports/IGP/IGPReportPOList";
import IGPReportDocument from "../pages/Reports/IGP/IGPReportDocument";

import MrItemsReports from "../pages/Reports/MrItemStatus/MrItemsReports";
import MrItemsReportList from "../pages/Reports/MrItemStatus/MrItemsReportList";

import VendorReports from "../pages/Reports/VendorList/VendorReports";
import VendorReportsList from "../pages/Reports/VendorList/VendorReportList";

import RfqPendingReports from "../pages/Reports/RfqPendingItems/RfqPendingReports";
import RfqPendingReportList from "../pages/Reports/RfqPendingItems/RfqPendingReportList";

import ItemReports from "../pages/Reports/ItemWise/ItemReports";
import ItemReportList from "../pages/Reports/ItemWise/ItemReportList";

import ProductStockReports from "../pages/Reports/ProductStockReport/ProductStockReports";
import ProductStockReportList from "../pages/Reports/ProductStockReport/ProductStockReportList";

//Audit Report
import AuditReport from "../pages/Audit_Report/AuditReports";
import AuditReportCard from "../pages/Audit_Report/AuditReportCard_View";
import SRPOReportList from "../pages/Reports/SRPurchaseOrder/SRPOReportList";
import SRPOReportAMCDocument from "../pages/Reports/SRPurchaseOrder/SRPOReportAMCDocument";
import POReportDetailedDocument from "../pages/Reports/PurchaseOrder/POReportDetailedDocument";
import AddOrderLocations from "../pages/MastersDashboard/OrderLocations/AddOrderLocations";
import AddOrderLocationTemplate from "../pages/MastersDashboard/OrderLocationTemplate/Add.OrderLocationTemplate";
import OrderLocationTemplate from "../pages/MastersDashboard/OrderLocationTemplate/OrderLocationTemplate";
import AddQuality from "../pages/MastersDashboard/quality/addQuality";
import ProductQuality from "../pages/MastersDashboard/productQuality/ProductQuality";
import MRTimelLineReports from "../pages/Reports/MRTimeLineReport/MRTimeLineReport";
import SRTimelLineReports from "../pages/Reports/SRTimeLineReport/SRTimeLineReport";
import CompareQuotationReportDocument from "../pages/CompareQuotation/CompareQuotationTask/CompareQuotationReportDocument";
const authProtectedRoutes = [
	{ path: "/dashboard", component: Dashboard },

	{ path: "/mrdashboard1", component: MyMRDashboard },
	{ path: "/srdashboard1", component: MySRDashboard },
	{ path: "/newmaterialrequest/:id", component: NewMaterialRequest },
	{ path: "/newservicerequest/:id", component: NewServiceRequest },
	{ path: "/materialrequest1/:id", component: MyMaterialRequest },
	{ path: "/servicerequest1/:id", component: MyServiceRequest },

	{ path: "/mrdashboard", component: MaterialRequestDashboard },
	{ path: "/srdashboard", component: ServiceRequestDashboard },
	{ path: "/MaterialRequest/:id", component: MaterialRequest },
	{ path: "/ServiceRequest/:id", component: ServiceRequest },

	{ path: "/mrdashboard2", component: DeptMRDashboard },
	{ path: "/srdashboard2", component: DeptSRDashboard },
	{ path: "/materialrequest2/:id", component: DeptMaterialRequest },
	{ path: "/servicerequest2/:id", component: DeptServiceRequest },

	{ path: "/allmrdashboard", component: AllMRDashboard },
	{
		path: "/allservicerequestdashboard",
		component: AllServiceRequestDashboard,
	},
	{ path: "/materialrequest3/:id", component: AllMaterialRequest },
	{ path: "/servicerequest3/:id", component: ServiceRequestView },
	{ path: "/compareQutdoc/:id", component: CompareQuotationReportDocument },


	{
		path: "/newpirequest/:id",
		component: NewPurchaseIndentRequest,
	},
	{
		path: "/newsrpirequest/:id",
		component: NewSRPurchaseIndentRequest,
	},
	{ path: "/pidashboard", component: MyPurchaseIndentDashboard },
	{ path: "/srpidashboard", component: MySRPurchaseIndentDashboard },
	{ path: "/pirequest/:id", component: PurchaseIndentRequest },
	{ path: "/srpirequest/:id", component: SRPurchaseIndentRequest },
	{ path: "/pidashboard1", component: HodPurchaseIndentDashboard },
	{ path: "/srpidashboard1", component: SRHodPurchaseIndentDashboard },
	{ path: "/pirequest1/:id", component: HodPurchaseIndentRequest },
	{ path: "/srrequest1/:id", component: HodSRPurchaseIndent },
	{
		path: "/rfqdashboard",
		component: RequestForQuotationDashboard,
	},
	{
		path: "/srrfqdashboard",
		component: SRRequestForQuotation,
	},
	{ path: "/newrfq/:id", component: NewRequestForQuotation },
	{ path: "/newsrrfq/:id", component: NewSRRequestForQuotation },
	{ path: "/rfq/:id", component: RequestForQuotation },
	{ path: "/srfq/:id", component: SRRequestForQuotationView },
	{ path: "/quotationdashboard", component: QuotationDashboard },
	{ path: "/srquotationdashboard", component: SRQuotationDashboard },
	{ path: "/NewQuotation/:id", component: NewQuotation },
	{ path: "/NewSRQuotation/:id", component: NewSRQuotation },
	{ path: "/NewWorkOrder/:id", component: NewWorkOrder },
	{ path: "/Quotation/:id", component: Quotation },
	{ path: "/SRQuotation/:id", component: SRQuotation },
	{
		path: "/CompareQuotationDashboard",
		component: CompareQuotationDashboard,
	},
	{
		path: "/SRCompareQuotationDashboard",
		component: SRCompareQuotationDashboard,
	},
	{ path: "/NewCompareQuotation/:id", component: NewCompareQuotation },
	{ path: "/NewSrCompareQuotation/:id", component: NewSRCompareQuotation },
	{ path: "/CompareQuotation/:id", component: CompareQuotation },
	{ path: "/SRCompareQuotation/:id", component: SRCompoareQuotation },

	{ path: "/PurchaseOrderDashboard", component: PurchaseOrderDashboard },
	{ path: "/SrPurchaseOrderDashboard", component: SRPurchaseOrder },
	{ path: "/PurchaseOrder/:id", component: PurchaseOrder },
	{ path: "/SrPurchaseOrder/:id", component: SRPurchaseOrderView },
	{ path: "/PurchaseOrderupdate/:id", component: PurchaseOrderEdit },

	{ path: "/igpdashboard", component: InGatePassDashboard },
	{ path: "/ingatepass/:id", component: InGatePass },
	{ path: "/newigp/:id", component: NewInGatePass },

	{ path: "/UserProfile", component: UserProfile },
	{ path: "/ChangePassword", component: ChangePassword },
	{ path: "/SystemSettings", component: SystemSettings },
	{ path: "/ExportCSV", component: ExportCSV },
	{ path: "/ImportCSV", component: ImportCSV },


	{ path: "/MastersDashboard", component: MastersDashboard },
	{ path: "/Getcompany", component: Companysetting },

	{ path: "/Users", component: Companylist },
	{ path: "/AddProfile/:id", component: AddProfile },
	{ path: "/EmailSMS", component: EmailSMS },
	{ path: "/ImportData", component: ImportData },
	{ path: "/yourdevices", component: Yourdevices },
	{ path: "/SecurityDashboard", component: SecurityDashboard },

	// Mater pages
	{ path: "/Companys", component: Companys },
	{ path: "/Menus", component: Menus },
	{ path: "/MenuItems", component: MenuItems },
	{ path: "/Departments", component: departments },
	{ path: "/Locations", component: locations },
	{ path: "/quality", component: quality },
	{ path: "/product/quality", component: ProductQuality },
	{ path: "/SubLocations", component: Sublocations },
	{ path: "/OrderLocations", component: OrderLocations },
	{ path: "/OrderLocationTemplate", component: OrderLocationTemplate },
	{ path: "/AddOrderLocations/:id", component: AddOrderLocations },
	{ path: "/AddOrderLocationTemplate/:id", component: AddOrderLocationTemplate },
	{ path: "/AddQuality/:id", component: AddQuality },
	{ path: "/ProductGroup", component: ProductGroup },
	{ path: "/Products", component: Products },
	{ path: "/AddProducts/:id", component: AddProducts },
	{ path: "/AddProductsQuality/:id", component: AddProductsQuality },

	{ path: "/Vendors", component: Vendors },
	// {path:"/AddVendor", component:AddVendor},
	// {path:"/AddProductVendor/:id", component:AddProductVendor},
	{ path: "/Category", component: Category },
	{ path: "/Section", component: Section },
	{ path: "/BasicUnit", component: BasicUnit },
	{ path: "/Taxs", component: Taxs },
	{ path: "/PrefixCode", component: PrefixCode },

	// Reports pages
	{ path: "/reports", component: ReportsDashboard },
	{ path: "/mrreport", component: MRReports },
	{ path: "/srreport", component: SRReports },
	{ path: "/mrreportlist", component: MRReportList },
	{ path: "/srreportlist", component: SRReportList },
	{ path: "/mrreportdoc/:id", component: MRReportDocument },
	{ path: "/srreportdoc/:id", component: SRReportDocument },
	{ path: "/mritemsreport", component: MrItemsReports },
	{ path: "/mritemsreportlist", component: MrItemsReportList },

	{ path: "/pireport", component: PIReports },
	{ path: "/mrtimelinereport", component: MRTimelLineReports },
	{ path: "/srtimelinereport", component: SRTimelLineReports },

	{ path: "/pireportlist", component: PIReportList },
	{ path: "/mrtimelinereportlist", component: MRTimelLineReportList },
	{ path: "/srtimelinereportlist", component: SRTimelLineReportList },
	{ path: "/pireportdoc/:id", component: PIReportDocument },
	{ path: "/mrtimelinereportdoc/:id", component: MRTimelLineReportDocument },
	{ path: "/srtimelinereportdoc/:id", component: SRTimelLineReportDocument },

	{ path: "/sireport", component: SIReports },
	{ path: "/sireportlist", component: SIReportList },
	{ path: "/sireportdoc/:id", component: SIReportDocument },

	{ path: "/rfqreport", component: RFQReports },
	{ path: "/rfqtopopendingreport", component: RFQToPPReports },
	{ path: "/rfqtopopendingreportlist", component: RFQToPPReportsList },


	{ path: "/rfqreportlist", component: RFQReportList },
	{ path: "/rfqreportdoc/:id", component: RFQReportDocument },
	{ path: "/rfqvendorwisereportdoc/:id", component: RFQVendorWiseReportDocument },


	{ path: "/srrfqreport", component: SRRFQReports },
	{ path: "/srrfqreportlist", component: SRRFQReportList },
	{ path: "/srrfqreportdoc/:id", component: SRReportDocument2 },

	{ path: "/qreport", component: QReports },
	{ path: "/qreportlist", component: QReportList },
	{ path: "/qreportdoc/:id", component: QReportDocument },

	{ path: "/srqreport", component: SRQReport },
	{ path: "/srqreportlist", component: SRQReportList },
	{ path: "/srqreportdoc/:id", component: SRQuotationReportDocument },

	{ path: "/unitreport", component: UnitReport },
	{ path: "/unitreportlist", component: UnitReportList },
	{ path: "/unitreportdoc/:id", component: UnitReportDocument },

	{ path: "/cqreport", component: CQReports },
	{ path: "/cqreportlist", component: CQReportList },
	{ path: "/cqreportdoc/:id", component: CQReportDocument },

	{ path: "/srcqreport", component: SRCQReports },
	{ path: "/srcqreportlist", component: SRCQReportList },
	{ path: "/srcqreportdoc/:id", component: SRCQReportDocument },

	{ path: "/poreport", component: POReports },
	{ path: "/poreportlist", component: POReportList },
	{ path: "/poreportdoc/:id", component: POReportDocument },
	{ path: "/podetailedreportdoc/:id", component: POReportDetailedDocument },
	{ path: "/poitemreportlist", component: POItemReportList },
	{ path: "/srporeport", component: SRPOReports },
	{ path: "/srporeportlist", component: SRPORTList },
	{ path: "/srporeportdoc/:id", component: SRPOReportDocument },
	{ path: "/srporeportamcdoc/:id", component: SRPOReportAMCDocument },
	{ path: "/srpoitemreportlist", component: SRPOItemReportList },

	{ path: "/pohistory", component: POAmendamentReports },
	{ path: "/pohistorylist/:id", component: POAmendamentReportList },
	{ path: "/pohistorydoc/:id", component: POAmendamentReportDocument },
	// { path: "/pohistoryitemreportlist", component: POHistoryItemReportList },

	{ path: "/igpreport", component: IGPReports },
	{ path: "/igpreportlist", component: IGPReportList },
	{ path: "/igpreportlist2", component: IGPReportPOList },
	{ path: "/igpreportdoc/:id", component: IGPReportDocument },

	{ path: "/vendorreports", component: VendorReports },
	{ path: "/vendorreportlist", component: VendorReportsList },

	{ path: "/RfqPendingReports", component: RfqPendingReports },
	{ path: "/RfqPendingReportList", component: RfqPendingReportList },

	{ path: "/ItemReports", component: ItemReports },
	{ path: "/ItemReportList", component: ItemReportList },

	{ path: "/ProductStockReports", component: ProductStockReports },
	{ path: "/ProductStockReportList", component: ProductStockReportList },

	//Audit Report
	{ path: "/AuditReport", component: AuditReport },
	{ path: "/AuditReportCard", component: AuditReportCard },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: Login },
	{ path: "/forgot-password", component: ForgetPwd },
	{ path: "/register", component: Register },
	{ path: "/auth-lock-screen", component: AuthLockScreen },
];
const vendorQuotation = [
	{ path: "/vendorlogin/:token", component: VendorLogin },
	{ path: "/VendorQuotation/:token", component: VendorQuotationLayout },

	{ path: "/vendorpo/:token", component: VendorPO },
	{ path: "/vendorquotationview/:token", component: VendorQuotationtReport },
];

export { authProtectedRoutes, publicRoutes, vendorQuotation };
